import { createFileRoute } from "@tanstack/react-router";

import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/office/places/create")({
  component: () => (
    <MaskRedirect
      to="/office/places/active"
      action="create-place"
      mask="/office/places/create"
    />
  ),
});
